import firebase from 'firebase';

export default function useFirebase() {
  return firebase;
}
